/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-01-05 10:30:50
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import React, { Component } from 'react';
import { InlineError, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Select from 'react-select';
import { RenderLabelTooltip } from './render-label-tooltip';
import { selectStyle } from './render-select.style';

type Props = WithI18nProps;

class RenderSelect3V2Component extends Component<Props> {
  state = {
    cacheUniq: 1
  };

  render() {
    const {
      meta,
      options,
      label,
      tooltip,
      input,
      isDisabled,
      textHelper,
      placeholderEmpty,
      i18n,
      components = {},
      styles = {},
      isSearchable = true,
      maxHeight,
      onChange,
      name,
      value,
      menuPosition = 'absolute'
    } = this.props;

    const hasError = !!meta?.error && !!meta?.touched;
    let { placeholder } = this.props;
    const emptyPlaceholder =
      placeholderEmpty !== undefined
        ? placeholderEmpty
        : i18n.translate('AdminHTML.Common.Empty.select_Placeholder');
    placeholder = _.isEmpty(options)
      ? emptyPlaceholder
      : placeholder || i18n.translate('AdminHTML.Common.Select.placeholder');

    return (
      <div className={hasError ? 'Polaris-TextField--error' : ''}>
        <RenderLabelTooltip label={label} tooltip={tooltip} />
        <Select
          id={name || input?.name}
          options={options}
          value={
            options.find(item => {
              return item.value === value || item.value === input?.value;
            }) || null
          }
          onChange={data => {
            onChange ? onChange(data?.value) : input.onChange(data?.value);
          }}
          label={label}
          styles={{ ...selectStyle, ...styles }}
          placeholder={placeholder}
          maxMenuHeight={maxHeight ? maxHeight : 150}
          // menuPortalTarget={document.body}
          classNamePrefix="BC-Select"
          isDisabled={isDisabled ? true : false}
          cacheUniq={this.state.cacheUniq}
          noOptionsMessage={() => i18n.translate('AdminHTML.Common.Empty.reactSelect_NoOptions')}
          components={components}
          isSearchable={isSearchable}
          menuPlacement="auto"
          menuPosition={menuPosition}
          blurInputOnSelect
        />

        {textHelper ? (
          <p style={{ marginTop: '0.25rem' }}>
            <TextStyle variation="subdued">{textHelper}</TextStyle>
          </p>
        ) : (
          ''
        )}
        {meta?.error ? <InlineError message={meta?.error} /> : ''}
      </div>
    );
  }
}

export const RenderSelect3V2 = withI18n()(RenderSelect3V2Component);
